<template lang="pug">
    v-dialog(
        v-model='dialog'
        max-width="600"
        persistent
        transition='dialog-bottom-transition'
    )
        v-card
            v-toolbar(dark color='green')
                v-toolbar-title Start Dial: Saved Place In Line

            v-card-text
                template(v-if="validPendingSavedPlaceInLineCall")
                    v-list(two-line)
                        template
                            v-list-item
                                v-list-item-content
                                    v-list-item-title {{ pendingSavedPlaceInLineCall.call_communication_queue.organization_name }}
                                    v-list-item-subtitle.text--primary(v-text='pendingSavedPlaceInLineCall.call_communication_queue.campaign_name')

                        template
                            v-divider(inset)
                            v-list-item
                                v-list-item-icon
                                    v-icon(color='primary')
                                        | mdi-phone
                                v-list-item-content
                                    v-list-item-title {{ pendingSavedPlaceInLineCall.call_communication_queue.communication_queue_name }}
                                    v-list-item-subtitle {{ pendingSavedPlaceInLineCall.call_communication_queue.language_name }}

                        template
                            v-divider(inset)
                            v-list-item
                                v-list-item-icon
                                    v-icon(color='primary')
                                        | mdi-clock
                                v-list-item-content
                                    v-list-item-title Customer Has Been Waiting For Callback For: {{ waitDuration }}
                                    v-list-item-subtitle Customer Wait Time

                        template
                            v-divider(inset)
                            v-list-item
                                v-list-item-icon
                                    v-icon(color='primary')
                                        | mdi-magnify
                                v-list-item-content
                                    v-list-item-title
                                        template(v-if="pendingSavedPlaceInLineCall.call_communication_queue.customer_match_code === 1") Perfect
                                        template(v-else-if="pendingSavedPlaceInLineCall.call_communication_queue.customer_match_code === 2") Multiple potential customers found
                                        template(v-else) No customer matches
                                    v-list-item-subtitle Match Status

                        template
                            v-divider(inset)
                            v-list-item
                                v-list-item-icon
                                    v-icon(color='primary')
                                        | mdi-account
                                v-list-item-content
                                    v-list-item-title
                                        template(v-if="pendingSavedPlaceInLineCall.call_communication_queue.customer_phone_number === '+266696687'") ANONYMOUS
                                        template(v-else) {{ pendingSavedPlaceInLineCall.call_communication_queue.customer_phone_number | tel }}
                                    v-list-item-subtitle Caller ID

                            v-list-item(v-if="validCustomerFullName")
                                v-list-item-icon
                                v-list-item-content
                                    v-list-item-title {{ pendingSavedPlaceInLineCall.call_communication_queue.customer_full_name }}
                                    v-list-item-subtitle Name

                        template(v-if="validCanceledMissedCall")
                            v-divider(inset)
                            v-list-item
                                v-list-item-icon
                                    v-icon(color='error')
                                        | mdi-alert
                                v-list-item-content
                                    v-list-item-title.error--text
                                        strong
                                            Timeago(
                                                :datetime="pendingSavedPlaceInLineCall.call_communication_queue.canceled_missed_call_created_at"
                                            )
                                    v-list-item-subtitle.error--text Previous Missed Call

                        v-row(align='center' justify="center")

                            v-tooltip(top)
                                template(v-slot:activator='{ on, attrs }')
                                    v-btn.mx-12.mt-4(v-bind='attrs' v-on='on' fab dark color='error' @click="handleAction(false, true);")
                                        v-icon(dark)
                                            | mdi-phone-hangup
                                span Decline Call

                            v-tooltip(top)
                                template(v-slot:activator='{ on, attrs }')
                                    v-btn.mx-12.mt-4(v-bind='attrs' v-on='on' fab dark color='green' @click="handleAction(true);")
                                        v-icon(dark)
                                            | mdi-phone
                                span Accept Call

</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        data() {
            return {
                dialog: true,
                ringingAudio: null,
                ringingAudioUrl: "https://volie-assets.s3.us-east-1.amazonaws.com/system/audio/phone_ringing_soft.mp3",
                systemAutoDeclineDuation: 13, // default
                timerDuration: 0,
                timerInterval: null,
            }
        },
        methods: {
            handleAction(accept, userClicked) {

                // Stop ringing
                this.stopRinging();

                // Stop timer
                this.stopTimer();

                // Close modal
                this.dialog = false;

                // Accept or decline depending on action
                if (accept === true) {
                    this.acceptSavedPlaceCall();
                } else {
                    console.debug("handleAction declineSavedPlaceCall: userClicked=" + userClicked);
                    this.declineSavedPlaceCall(userClicked === true);
                }
            },
            incrementTimer() {
                this.timerDuration += 1;
            },
            initRingingAudio() {
                if (!this.ringingAudioUrl) {
                    return;
                }

                this.ringingAudio = new Audio(this.ringingAudioUrl);
            },
            playRinging() {
                if (!this.ringingAudio) {
                    return;
                }

                this.ringingAudio.play().catch(() => {});
            },
            startTimer() {
                this.timerInterval = setInterval(this.incrementTimer, 1000);
            },
            stopRinging() {
                if (!this.ringingAudio) {
                    return;
                }

                this.ringingAudio.pause();
            },
            stopTimer() {
                if (!this.timerInterval) {
                    return;
                }

                clearInterval(this.timerInterval);
            },
        },
        computed: {
            validCustomerFullName() {
                return this.pendingSavedPlaceInLineCall?.call_communication_queue?.customer_id > 0 && this.pendingSavedPlaceInLineCall.call_communication_queue?.customer_full_name?.length > 0;
            },
            validCanceledMissedCall() {
                return this.pendingSavedPlaceInLineCall?.call_communication_queue?.canceled_missed_call_id > 0;
            },
            validPendingSavedPlaceInLineCall() {
                return this.pendingSavedPlaceInLineCall?.call_communication_queue?.call_communication_queue_id > 0 && this.pendingSavedPlaceInLineCall?.call_communication_queue?.status === "ivr_callback_pending";
            },
            waitDuration() {

                if (!this.pendingSavedPlaceInLineCall.scheduled_communication_created_at) {
                    return "Unknown";
                }

                const startTime = new Date(this.pendingSavedPlaceInLineCall.scheduled_communication_created_at);
                const currentTime = new Date();

                // Calculate total elapsed time in milliseconds
                const diffMs = currentTime.getTime() - startTime.getTime();

                // Convert to minutes and seconds
                const totalSeconds = Math.floor(diffMs / 1000);
                const minutes = Math.floor(totalSeconds / 60);
                const seconds = totalSeconds % 60;

                // return formatted string
                return minutes + "m and " + seconds + "s";
            }
        },
        components: {
        },
        props: {
            acceptSavedPlaceCall: Function,
            declineSavedPlaceCall: Function,
            pendingSavedPlaceInLineCall: Object,
        },
        watch: {
            timerDuration() {
                return this.dialog === true && this.timerDuration === this.systemAutoDeclineDuation ? this.handleAction(false, false) : null;
            },
        },
        created() {
            this.initRingingAudio();
            this.playRinging();
            this.startTimer();
        },
        destroyed() {
            this.stopRinging();
            this.stopTimer(); // to be safe in avoiding memory leaks
        },
    });
</script>

<style lang="scss" scoped>
</style>
